<template>
    <div>
      <van-nav-bar
        title="收藏职位"
        left-arrow
        fixed
        placeholder
        @click-left="onClickLeft">
      </van-nav-bar>
      <ul class="job-list">
        <li v-for="item in jobs" :key="item.index" @click="jobDetail">
          <div class="detail-info">
            <div class="info-header">
              <h3>{{item.title}} <small>急</small> </h3>
              <span>{{item.wages}}</span>
            </div>
            <ul class="conditionList">
              <li v-for="condition in item.conditionList" :key="condition.index">
                {{condition.detail}}
              </li>
            </ul>
            <ul class="feature">
              <li v-for="feature in item.featurelist" :key="feature.index">
                {{feature.detail}}
              </li>
            </ul>
            <div class="contact">
              <div class="person">
                <img :src='item.person'>
                <span>{{item.name}}</span>
              </div>
              <div class="place">
                {{item.place}}
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
</template>

<script>
export default {
  name: 'collectionJobs',
  data() {
    return {
      jobs: [
        {
          title: '组件工程师维修班长',
          wages: '8000-12000',
          person: require('@/assets/img/user.png'),
          name: '刘经理·人事',
          place: '嘉定新城',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        },
        {
          title: '组件工程师维修班长',
          wages: '8000-12000',
          person: require('@/assets/img/user.png'),
          name: '刘经理·人事',
          place: '嘉定新城',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        },
        {
          title: '组件工程师维修班长',
          wages: '8000-12000',
          person: require('@/assets/img/user.png'),
          name: '刘经理·人事',
          place: '嘉定新城',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        },
        {
          title: '组件工程师维修班长',
          wages: '8000-12000',
          person: require('@/assets/img/user.png'),
          name: '刘经理·人事',
          place: '嘉定新城',
          featurelist: [
            {
              detail: '上海航天电子有限公司'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ],
          conditionList: [
            {
              detail: '3-5年'
            }, {
              detail: '学历不限'
            }
          ]
        }
      ]
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
  .job-list{
    margin-left: 0;
    margin-right: 0;
    margin-top: 10px;
    &>li{
      padding:6px 16px;
      border-bottom: 8px solid #F7F7F7;
      &:last-child{
        border-bottom: 0;
      }
    }
  }
</style>
